import { render, staticRenderFns } from "./BetSeasonResultsView.vue?vue&type=template&id=242314a6&"
import script from "./BetSeasonResultsView.vue?vue&type=script&lang=js&"
export * from "./BetSeasonResultsView.vue?vue&type=script&lang=js&"
import style0 from "./BetSeasonResultsView.vue?vue&type=style&index=0&id=242314a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports